import React, { useContext, useState } from "react";
import { Field } from "formik";
import {
  FieldInput,
  FieldButtonGroup,
  MultiSelectDropdown,
  FieldDropSide,
  FieldInputDecimal,
  FieldInputPercentage,
} from "../../../components";
import { useRequest, useDeepEffect } from "../../../abstracts";
import {
  getEmployeeEmployeeDeferrals,
  getEmploymentStatusList,
} from "../../../services";
import {
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  clearFieldValues,
  yesNoOptions,
  SOURCE_CATEGORY_NAME_MAPPING,
  SOURCE_SUB_CATEGORY_NAME_MAPPING,
  toMultiSelectValueById,
  tranformListToDropdownValues,
  errors,
} from "../../../utils";
import SafeHarbourMatchRules from "./SafeHarbourMatchRules";
import { createPlanStore } from "../../../contexts";
import { listSource } from "../../../services";
import { get } from "lodash";
import NonPayPeriodAllocation from "./NonPayPeriodAllocation";

const EmployerAllocationRules = (props) => {
  const {
    fields,
    setFieldValue,
    setFieldError,
    isEdit,
    isSave,
    values,
    handleChange,
    setValues,
    planId,
  } = props;
  const { loading, response } = useRequest({
    method: getEmployeeEmployeeDeferrals,
    defaultResponse: [],
  });
  const isClient = parseInt(values[fields.responsibleMode], 10) === 1;
  const isCore = parseInt(values[fields.responsibleMode], 10) === 2;
  const isValidate = parseInt(values[fields.responsibleMode], 10) === 3;
  const isDiscretionary = parseInt(values[fields.sourceCategory], 10) === 5;
  const isAdiApplicableToMatch =
    parseInt(values[fields.sourceCategory], 10) ===
    SOURCE_CATEGORY_NAME_MAPPING.Match;
  const isAdiApplicableToMatchRoth =
    parseInt(values[fields.sourceCategory], 10) ===
    SOURCE_CATEGORY_NAME_MAPPING.MatchRoth;
  const { state, dispatch } = useContext(createPlanStore);
  const [sourcesApiData, setSourcesApiData] = useState([]);
  useDeepEffect(() => {
    listSource(parseInt(planId))
      .then((response) => {
        setSourcesApiData(response.employerSourcesList);
      })
      .catch((error) => {
        //Handle Error
      });
  }, []);

  const deferralSources = sourcesApiData
    ?.filter((val) => val.sourceCategory === 2 && val.sourceSubCategory !== 6)
    ?.map((source) => ({
      label: source.sourceName,
      value: source.id,
    }));
  const handleEmployerMatchContrChange = (value) => {
    setValues({
      ...clearFieldValues({
        values,
        fieldsToClear: [
          fields.percentageOfCalculation,
          fields.percentageOfCompensationMatched,
          fields.firstTierMatchPercent,
          fields.secondTierMatchPercent,
          fields.thirdTierMatchPercent,
          fields.firstTierCompensationMatchPercent,
          fields.secondTierCompensationMatchPercent,
          fields.thirdTierCompensationMatchPercent,
        ],
      }),
      [fields.employerContributionType]: value,
    });
  };
  const handleresponsibleMode = (value) => {
    if (values[fields.isSafeHarbourMatch]) {
      setValues({
        ...clearFieldValues({
          values,

          fieldsToClear: [
            fields.eligiblePaymentType,
            fields.employerContributionType,
            fields.percentageOfCompensation,
            fields.periodForCalculation,
            fields.isCatchApplicable,
            fields.isCalculationSuspended,
            fields.isTrueUpApplicable,
            fields.isLastDayRuleApplicable,
            // fields.isSafeHarbourMatch,
            // fields.safeHarbourType,
            fields.enhancedshMatchPercentage,
            fields.uptoPercentageOfDeferral,
            fields.percentageOfCalculation,
            fields.percentageOfCompensationMatched,
            fields.firstTierMatchPercent,
            fields.secondTierMatchPercent,
            fields.thirdTierMatchPercent,
            fields.firstTierCompensationMatchPercent,
            fields.secondTierCompensationMatchPercent,
            fields.thirdTierCompensationMatchPercent,
            fields.sourceOfMatch,
          ],
        }),
        [fields.responsibleMode]: value,
        [fields.eligiblePaymentType]: 1,
        [fields.isCatchApplicable]: true,
        [fields.isThresholdApplicable]: true,
        [fields.isTrueUpApplicable]: false,
        [fields.isLastDayRuleApplicable]: false,
        [fields.safeHarbourType]: 1,
      });
    } else {
      setValues({
        ...clearFieldValues({
          values,

          fieldsToClear: [
            fields.eligiblePaymentType,
            fields.employerContributionType,
            fields.percentageOfCompensation,
            fields.periodForCalculation,
            fields.isCatchApplicable,
            fields.isCalculationSuspended,
            fields.isTrueUpApplicable,
            fields.isLastDayRuleApplicable,
            // fields.isSafeHarbourMatch,
            // fields.safeHarbourType,
            fields.enhancedshMatchPercentage,
            fields.uptoPercentageOfDeferral,
            fields.percentageOfCalculation,
            fields.percentageOfCompensationMatched,
            fields.firstTierMatchPercent,
            fields.secondTierMatchPercent,
            fields.thirdTierMatchPercent,
            fields.firstTierCompensationMatchPercent,
            fields.secondTierCompensationMatchPercent,
            fields.thirdTierCompensationMatchPercent,
            fields.sourceOfMatch,
          ],
        }),
        [fields.responsibleMode]: value,
        [fields.eligiblePaymentType]: 1,
        [fields.isCatchApplicable]: false,
        [fields.isThresholdApplicable]: true,
        [fields.isTrueUpApplicable]: false,
        [fields.isLastDayRuleApplicable]: false,
        [fields.safeHarbourType]: 1,
        [fields.isNonPayPeriodApplicable]: false,
      });
    }
    setFieldError([fields.sourceOfMatch], "");
    setFieldError([fields.employerContributionType], "");
    setFieldError([fields.enhancedshMatchPercentage], "");
    setFieldError([fields.percentageOfCompensation], "");
    setFieldError([fields.periodForCalculation], "");
    setFieldError([fields.enhancedshMatchPercentage], "");
    setFieldError([fields.uptoPercentageOfDeferral], "");
    setFieldError([fields.percentageOfCalculation], "");
    setFieldError([fields.percentageOfCompensationMatched], "");
    setFieldError([fields.firstTierMatchPercent], "");
    setFieldError([fields.secondTierMatchPercent], "");
    setFieldError([fields.thirdTierMatchPercent], "");
    setFieldError([fields.firstTierCompensationMatchPercent], "");
    setFieldError([fields.secondTierCompensationMatchPercent], "");
    setFieldError([fields.thirdTierCompensationMatchPercent], "");
  };
  const selectedSourceOfMatch = values[fields.sourceOfMatch];
  const sourceCategory = parseInt(values[fields.sourceCategory], 10);
  const isAdiApplicableToOther =
    sourceCategory &&
    sourceCategory === SOURCE_CATEGORY_NAME_MAPPING.EmployerOther;
  const isSubCatergoryQmac =
    values[fields.sourceSubCategory] &&
    parseInt(values[fields.sourceSubCategory], 10) ===
      SOURCE_SUB_CATEGORY_NAME_MAPPING.QMAC;
  const isSafeHarbourMatch = values[fields.isSafeHarbourMatch];
  const isCalculationSuspended = values[fields.isCalculationSuspended];
  const isCatchApplicableDisabled = (isEdit && !isSave) || isSafeHarbourMatch;
  const [filteredValues, setFilteredValues] = useState([]);

  useDeepEffect(() => {
    getEmploymentStatusList(get(state, "api.reviewAndPlanDetail.companyId", 0))
      .then((response) => {
        setFilteredValues(
          response
            .filter((x) => x.employmentStatus !== 1)
            .map((val) => ({
              label: val.employmentStatusName,
              value: val.id,
            }))
        );
      })
      .catch((error) => {
        //Handle Error
      });
  }, []);

  return (
    <div>
      {!isAdiApplicableToOther ? (
        values[fields.sourceCategory] == 10 ? (
          <Field
            isRequired
            name={fields.responsibleMode}
            label="Responsible for calculation"
            options={toOptionValuesFromMapper({
              1: "Client",
            })}
            selectedValue={values[fields.responsibleMode]}
            onChange={handleresponsibleMode}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="md"
          />
        ) : (
          <Field
            isRequired
            name={fields.responsibleMode}
            label="Responsible for calculation"
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.SOURCES_EMPLOYER_RESPONSIBLE_FOR_CALC
            )}
            selectedValue={values[fields.responsibleMode]}
            onChange={handleresponsibleMode}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="md"
          />
        )
      ) : null}
       {values[fields.isSafeHarbourMatch] == true && values[fields.sourceCategory] == SOURCE_CATEGORY_NAME_MAPPING.Discretionary && 
        <Field
        isRequired
        name={fields.safeHarbourType}
        label="Types of Safe harbour match"
        options={toOptionValuesFromMapper(
          OPTIONS_DATA_MAPPER.SOURCE_SAFE_HARBOUR_CATEGORIES
        )}
        selectedValue={values[fields.safeHarbourType]}
        onChange={(value) => {
          setFieldValue(fields.safeHarbourType, value);
        }}       
        disabled={isEdit && !isSave}
        component={FieldButtonGroup}
      />
      }
      {isCore && (
        <div>
          {/* {values[fields.sourceCategory] === 5 && (
            <Field
              name={fields.isSafeHarbourMatch}
              label="Safe harbour match?"
              options={yesNoOptions}
              selectedValue={values[fields.isSafeHarbourMatch]}
              onChange={(value) => {
                setFieldValue(fields.isSafeHarbourMatch, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
            />
          )} */}
          {(values[fields.sourceCategory] === 5 ||
            values[fields.sourceCategory] === 8) && (
            <Field
              name={fields.isCalculationSuspended}
              label="Calculation Suspended?"
              options={yesNoOptions}
              selectedValue={values[fields.isCalculationSuspended]}
              onChange={(value) => {
                setFieldValue(fields.isCalculationSuspended, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="sm"
            />
          )}
          {(values[fields.sourceCategory] === 5 ||
            values[fields.sourceCategory] === 8) && (
            <Field
              isRequired
              name={fields.isTrueUpApplicable}
              label="is Trueup Applicable?"
              options={yesNoOptions}
              selectedValue={values[fields.isTrueUpApplicable]}
              onChange={(value) => {
                setFieldValue(fields.isTrueUpApplicable, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="sm"
            />
          )}

          <Field
            isRequired
            name={fields.eligiblePaymentType}
            label="Eligible Pay Determination based on"
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.SOURCES_ELIGIBLE_PAY_DETERMINATION
            )}
            selectedValue={values[fields.eligiblePaymentType]}
            onChange={(value) => {
              setFieldValue(fields.eligiblePaymentType, value);
            }}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
          />

          {(values[fields.sourceCategory] === 5 ||
            values[fields.sourceCategory] === 8) && (
            <>
              {!(
                  values[fields.isSafeHarbourMatch] === true &&
                  parseInt(values[fields.safeHarbourType], 10) === 2
                ) && (
                <>
                  <Field
                    isRequired
                    name={fields.employerContributionType}
                    label="Employer Contribution Type"
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.SOURCE_EMPLOYER_DISCRETIONARY_CONTR_TYPE
                    )}
                    selectedValue={values[fields.employerContributionType]}
                    onChange={handleEmployerMatchContrChange}
                    disabled={isEdit && !isSave}
                    component={FieldButtonGroup}
                    size="lg"
                  />
                  <Field
                    isRequired
                    name={fields.percentageOfCompensation}
                    label="Percentage of Compensation"
                    type="number"
                    min={0}
                    autoComplete="off"
                    value={values[fields.percentageOfCompensation]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                    hasSuggestion
                    // suggestionDefaultText="%"
                    shouldDisplaySuggestion
                    size="xs"
                  />
                  </>
                )}
              <Field
                isRequired
                name={fields.periodForCalculation}
                label="Period of calculation"
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.PERIOD_OF_CALCULATION
                )}
                selectedValue={values[fields.periodForCalculation]}
                onChange={(value) => {
                  setFieldValue(fields.periodForCalculation, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="smd"
              />
              <NonPayPeriodAllocation {...props} />
            </>
          )}
          {(isAdiApplicableToMatch || isAdiApplicableToMatchRoth) && (
            <>
              <Field
                isRequired
                label="Source of Match"
                name={fields.sourceOfMatch}
                value={toMultiSelectValueById(
                  selectedSourceOfMatch,
                  deferralSources
                )}
                isMultiSelect
                popupContent={
                  <MultiSelectDropdown
                    label="Select Sources of Match"
                    name={fields.sourceOfMatch}
                    onSelect={(value) =>
                      setFieldValue(fields.sourceOfMatch, value)
                    }
                    value={values[fields.sourceOfMatch]}
                    options={deferralSources}
                    isLoading={loading}
                    disabled={isEdit && !isSave}
                  />
                }
                disabled={isEdit && !isSave}
                component={FieldDropSide}
              />
              <Field
                name={fields.isLastDayRuleApplicable}
                label="Last Day Rule Applicable"
                options={yesNoOptions}
                selectedValue={values[fields.isLastDayRuleApplicable]}
                onChange={(value) => {
                  setFieldValue(fields.isLastDayRuleApplicable, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="sm"
                isRequired
              />

              {values[fields.isLastDayRuleApplicable] == true && (
                <div className="sources-select-employmentsources">
                  <div className="mb-15">
                    <Field
                      isRequired
                      name={fields.employmentStatus}
                      label={"Employment Status"}
                      value={toMultiSelectValueById(
                        values[fields.employmentStatus],
                        filteredValues
                      )}
                      isMultiSelect
                      popupContent={
                        <MultiSelectDropdown
                          isTypeAhead
                          options={filteredValues}
                          maxHeight="180px"
                          height="160px"
                          label={"Search"}
                          hideSelectAll={false}
                          onSelect={(value) =>
                            setFieldValue(fields.employmentStatus, value)
                          }
                          value={values[fields.employmentStatus]}
                          disabled={isEdit && !isSave}
                        />
                      }
                      disabled={isEdit && !isSave}
                      component={FieldDropSide}
                    />
                  </div>
                </div>
              )}
              <SafeHarbourMatchRules {...props} />
              <Field
                isRequired
                name={fields.periodForCalculation}
                label="Period of calculation"
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.PERIOD_OF_CALCULATION
                )}
                selectedValue={values[fields.periodForCalculation]}
                onChange={(value) => {
                  setFieldValue(fields.periodForCalculation, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="smd"
              />
              <Field
                name={fields.isCalculationSuspended}
                label="Calculation Suspended?"
                options={yesNoOptions}
                selectedValue={values[fields.isCalculationSuspended]}
                onChange={(value) => {
                  setFieldValue(fields.isCalculationSuspended, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="sm"
              />

              <Field
                isRequired
                name={fields.isCatchApplicable}
                label="Is Catchup Applicable?"
                options={yesNoOptions}
                selectedValue={
                  values[fields.isSafeHarbourMatch]
                    ? values[fields.isSafeHarbourMatch]
                    : values[fields.isCatchApplicable]
                }
                onChange={(value) => {
                  setFieldValue(fields.isCatchApplicable, value);
                }}
                disabled={isCatchApplicableDisabled}
                component={FieldButtonGroup}
                size="sm"
              />
              <Field
                isRequired
                name={fields.isTrueUpApplicable}
                label="Is Trueup Applicable?"
                options={yesNoOptions}
                selectedValue={values[fields.isTrueUpApplicable]}
                onChange={(value) => {
                  setFieldValue(fields.isTrueUpApplicable, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="sm"
              />
              <NonPayPeriodAllocation {...props} />
            </>
          )}
        </div>
      )}

      {isValidate && (
        <div>
          {
            <Field
              isRequired
              name={fields.isThresholdApplicable}
              label="Threshold applicable?"
              options={yesNoOptions}
              selectedValue={values[fields.isThresholdApplicable]}
              onChange={(value) => {
                setFieldValue(fields.isThresholdApplicable, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="sm"
            />
          }
          {/* {values[fields.sourceCategory] === 5 && (
            <Field
              name={fields.isSafeHarbourMatch}
              label="Safe harbour match?"
              options={yesNoOptions}
              selectedValue={values[fields.isSafeHarbourMatch]}
              onChange={(value) => {
                setFieldValue(fields.isSafeHarbourMatch, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
            />
          )} */}

          {(values[fields.sourceCategory] === 5 ||
            values[fields.sourceCategory] === 8) && (
            <Field
              name={fields.isCalculationSuspended}
              label="Calculation Suspended?"
              options={yesNoOptions}
              selectedValue={values[fields.isCalculationSuspended]}
              onChange={(value) => {
                setFieldValue(fields.isCalculationSuspended, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="sm"
            />
          )}
          {(values[fields.sourceCategory] === 5 ||
            values[fields.sourceCategory] === 8) && (
            <Field
              isRequired
              name={fields.isTrueUpApplicable}
              label="is Trueup Applicable?"
              options={yesNoOptions}
              selectedValue={values[fields.isTrueUpApplicable]}
              onChange={(value) => {
                setFieldValue(fields.isTrueUpApplicable, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="sm"
            />
          )}
          <Field
            isRequired
            name={fields.eligiblePaymentType}
            label="Eligible Pay Determination based on"
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.SOURCES_ELIGIBLE_PAY_DETERMINATION
            )}
            selectedValue={values[fields.eligiblePaymentType]}
            onChange={(value) => {
              setFieldValue(fields.eligiblePaymentType, value);
            }}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
          />
          {!isAdiApplicableToMatch && !isAdiApplicableToMatchRoth && (
            <>
                {!(
                  values[fields.isSafeHarbourMatch] === true &&
                  parseInt(values[fields.safeHarbourType], 10) === 2
                ) && (
                <>

                  <Field
                    isRequired
                    name={fields.employerContributionType}
                    label="Employer Contribution Type"
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.SOURCE_EMPLOYER_DISCRETIONARY_CONTR_TYPE
                    )}
                    selectedValue={values[fields.employerContributionType]}
                    onChange={handleEmployerMatchContrChange}
                    disabled={isEdit && !isSave}
                    component={FieldButtonGroup}
                    size="lg"
                  />
              
                  <Field
                    isRequired
                    name={fields.percentageOfCompensation}
                    label="Percentage of Compensation"
                    type="number"
                    min={0}
                    autoComplete="off"
                    value={values[fields.percentageOfCompensation]}
                    onChange={handleChange}
                    disabled={isEdit && !isSave}
                    component={FieldInputPercentage}
                    hasSuggestion
                    // suggestionDefaultText="%"
                    shouldDisplaySuggestion
                    size="xs"
                  />
                </>
                )}
              
              <Field
                isRequired
                name={fields.periodForCalculation}
                label="Period of calculation"
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.PERIOD_OF_CALCULATION
                )}
                selectedValue={values[fields.periodForCalculation]}
                onChange={(value) => {
                  setFieldValue(fields.periodForCalculation, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="lg"
              />
              <NonPayPeriodAllocation {...props} />
            </>
          )}
          {(isAdiApplicableToMatch || isAdiApplicableToMatchRoth) && (
            <>
              <Field
                isRequired
                label="Source of Match"
                name={fields.sourceOfMatch}
                value={toMultiSelectValueById(
                  selectedSourceOfMatch,
                  deferralSources
                )}
                isMultiSelect
                popupContent={
                  <MultiSelectDropdown
                    label="Select Sources of Match"
                    name={fields.sourceOfMatch}
                    onSelect={(value) =>
                      setFieldValue(fields.sourceOfMatch, value)
                    }
                    value={values[fields.sourceOfMatch]}
                    options={deferralSources}
                    isLoading={loading}
                    disabled={isEdit && !isSave}
                  />
                }
                disabled={isEdit && !isSave}
                component={FieldDropSide}
              />
              <SafeHarbourMatchRules {...props} />
              <Field
                isRequired
                name={fields.periodForCalculation}
                label="Period of calculation"
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.PERIOD_OF_CALCULATION
                )}
                selectedValue={values[fields.periodForCalculation]}
                onChange={(value) => {
                  setFieldValue(fields.periodForCalculation, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="lg"
              />
              <Field
                name={fields.isCalculationSuspended}
                label="Calculation Suspended?"
                options={yesNoOptions}
                selectedValue={values[fields.isCalculationSuspended]}
                onChange={(value) => {
                  setFieldValue(fields.isCalculationSuspended, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="sm"
              />
              <Field
                isRequired
                name={fields.isCatchApplicable}
                label="Is Catchup Applicable?"
                options={yesNoOptions}
                selectedValue={
                  values[fields.isSafeHarbourMatch]
                    ? values[fields.isSafeHarbourMatch]
                    : values[fields.isCatchApplicable]
                }
                onChange={(value) => {
                  setFieldValue(fields.isCatchApplicable, value);
                }}
                disabled={isCatchApplicableDisabled}
                component={FieldButtonGroup}
                size="sm"
              />
              <Field
                isRequired
                name={fields.isTrueUpApplicable}
                label="is Trueup Applicable?"
                options={yesNoOptions}
                selectedValue={values[fields.isTrueUpApplicable]}
                onChange={(value) => {
                  setFieldValue(fields.isTrueUpApplicable, value);
                }}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="sm"
              />
              <NonPayPeriodAllocation {...props} />
            </>
          )}
        </div>
      )}
      {isClient && (isAdiApplicableToMatch || isAdiApplicableToMatchRoth) && (
        <>
          <Field
            isRequired
            label="Source of Match"
            name={fields.sourceOfMatch}
            value={toMultiSelectValueById(
              selectedSourceOfMatch,
              deferralSources
            )}
            isMultiSelect
            popupContent={
              <MultiSelectDropdown
                label="Select Sources of Match"
                name={fields.sourceOfMatch}
                onSelect={(value) => setFieldValue(fields.sourceOfMatch, value)}
                value={values[fields.sourceOfMatch]}
                options={deferralSources}
                isLoading={loading}
                disabled={isEdit && !isSave}
              />
            }
            disabled={isEdit && !isSave}
            component={FieldDropSide}
          />
          <SafeHarbourMatchRules {...props} />
          <NonPayPeriodAllocation {...props} />
        </>
      )}
      {isClient &&
  (parseInt(values[fields.sourceCategory], 10) ===
    SOURCE_CATEGORY_NAME_MAPPING.Discretionary ||
    parseInt(values[fields.sourceCategory], 10) ===
      SOURCE_CATEGORY_NAME_MAPPING.NonElectiveRoth) && (
    <>
      {!(
        values[fields.isSafeHarbourMatch] === true &&
        parseInt(values[fields.safeHarbourType], 10) === 2
      ) && (
        <>
          <Field
            isRequired
            name={fields.employerContributionType}
            label="Employer Contribution Type"
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.SOURCE_EMPLOYER_DISCRETIONARY_CONTR_TYPE
            )}
            selectedValue={values[fields.employerContributionType]}
            onChange={handleEmployerMatchContrChange}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="lg"
          />
          <Field
            isRequired
            name={fields.percentageOfCompensation}
            label="Percentage of Compensation"
            type="number"
            min={0}
            autoComplete="off"
            value={values[fields.percentageOfCompensation]}
            onChange={handleChange}
            disabled={isEdit && !isSave}
            component={FieldInputPercentage}
            hasSuggestion
            // suggestionDefaultText="%"
            shouldDisplaySuggestion
            size="xs"
          />
        </>
      )}
      <NonPayPeriodAllocation {...props} />
    </>
  )}
    </div>
  );
};

export default EmployerAllocationRules;
